import UserMenuGroupItem from './UserMenuGroupItem';
import UserMenuGroupAction from './UserMenuGroupAction';
import { jsx as _jsx } from "react/jsx-runtime";

const UserMenuGroup = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "user-menu-group",
    children: children
  });
};

UserMenuGroup.Item = UserMenuGroupItem;
UserMenuGroup.Action = UserMenuGroupAction;
export default UserMenuGroup;